import { render } from "./oilprice.vue?vue&type=template&id=52f6c069&scoped=true"
import script from "./oilprice.vue?vue&type=script&lang=js"
export * from "./oilprice.vue?vue&type=script&lang=js"

import "./oilprice.vue?vue&type=style&index=0&id=52f6c069&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-52f6c069"

export default script